/**
 * Created by jehe on 17.04.2020.
 */
import stringInject from "stringinject";
import creator from "../elementCreator";
import globals from "../globals";
import infotextGenerator from "../kp_extended_info";

import Style from "ol/style/Style.js";
import Icon from "ol/style/Icon.js";
import Feature from "ol/Feature.js";
import Point from "ol/geom/Point.js";
import Collection from "ol/Collection.js";
import WFS from "ol/format/WFS.js";
import WKT from "ol/format/WKT.js";

/*jslint browser: true*/
("use strict");
var config;
var privateFns;
privateFns = {
  addFeatureInfoTopDiv: function () {
    var div = creator.createDiv({ css: "top-div" });
    div.appendChild(
      creator.createButton({
        css: "close-me-featureinfo",
        ariaLabel: "lukk kontekstmeny",
        icon: true,
        iconClass: "icon-Close",
        onclick: function () {
          $(".featureinfo").removeClass("aside-show");
          $(".featureinfo-tip").removeClass("featureinfo-tip-hide");
          globals.clearMap("keepHighlight");
          setTimeout(function () {
            $(".featureinfo").hide();
          }, 500);
        },
      }),
    );
    div.appendChild(
      creator.createButton({
        css: "minimize-me",
        ariaLabel: "minimer kontekstmeny",
        id: "contextMinimize",
        icon: true,
        iconClass: "fa fa-window-minimize",
        onclick: function (e) {
          $($("#contextMinimize")[0].parentElement.parentElement).toggleClass(
            "featureinfo-minimized",
          );
          $("#contextMinimize")
            .find("i")
            .toggleClass("fa-window-minimize")
            .toggleClass("fa-window-maximize");
        },
      }),
    );
    return div;
  },
  addTabMenu: function (title1, title2) {
    var div = creator.createDiv({ css: "tab-menu" });
    var ul = creator.createUl({
      css: "nav nav-tabs",
    });
    ul.appendChild(
      creator.createLi({
        css: "active",
        id: "tab-eiendom",
        text: "<a href='#'>" + title1 + "</a>",
      }),
    );
    ul.appendChild(
      creator.createLi({
        id: "tab-punkt",
        text: "<a href='#'>" + title2 + "</a>",
      }),
    );
    div.appendChild(ul);
    $(ul)
      .find("a")
      .click(function (e) {
        var targets = $(ul).find("li");
        e.preventDefault();
        if ($(e.currentTarget.parentElement).hasClass("active") === false) {
          targets.removeClass("active");
          $(e.currentTarget.parentElement).addClass("active");
          if (e.currentTarget.parentElement.id === "tab-punkt") {
            $(".feature-info-eiendom").hide();
            $(".feature-info-punkt").show();
          } else if (e.currentTarget.parentElement.id === "tab-eiendom") {
            $(".feature-info-punkt").hide();
            $(".feature-info-eiendom").show();
          } else {
            console.error("Ukjent tab-id..");
          }
        }
      });
    return div;
  },
  addEiendomFeatureInfo: function (bottom, fields) {
    var section = creator.createSection({
      css: "featureinfo-wrapper feature-info-eiendom",
    });
    section.appendChild(
      creator.createDiv({
        id: "eiendom-info-ct",
        css: "feature-info-ct",
      }),
    );
    fields.forEach(function (field) {
      if (!field.fields) {
        section.appendChild(privateFns.addFeatureInfoField("", field));
      } else {
        var parentField = privateFns.addFeatureInfoHeader("", field);
        field.fields.forEach(function (subFields) {
          parentField.appendChild(
            privateFns.addFeatureInfoField("", subFields),
          );
        });
        section.appendChild(parentField);
      }
    });
    if (bottom) {
      section.appendChild(privateFns.addDyplenkeField(bottom));
    }
    return section;
  },
  addFeatureInfoHeader: function (idPrefix, field) {
    var wrapper = creator.createDiv({
      css: "feature-info-ct",
      id: idPrefix + field.id + "-info-ct",
    });
    wrapper.style.marginBottom = "10px";
    var heading = creator.createButton({
      css: "info-heading-header navtogglerActive",
    });
    heading.appendChild(
      creator.createH3({
        text: field.title,
      }),
    );
    heading.appendChild(
      creator.createIcon({
        className: "icon-Close context-icon-style",
      }),
    );
    if (field.featureCount) {
      heading.appendChild(
        creator.createSpan({
          css: "feature-count",
          text: 0,
        }),
      );
    }

    $(heading).click(function (e) {
      $(e.currentTarget)
        .parent()
        .children(".feature-info-ct")
        .toggle(300, function () {});
      $(".feature-info-ct").each(function (idx, el) {
        if (el.parentElement != heading && $(el).hasClass("icon-Close")) {
          $(el)
            .toggleClass("glyphicon glyphicon-option-vertical")
            .toggleClass("icon-Close");
        }
      });
      $(heading)
        .toggleClass("navtogglerStyler")
        .toggleClass("navtogglerActive");
      $(heading)
        .find("i")
        .toggleClass("glyphicon glyphicon-option-vertical")
        .toggleClass("icon-Close");
    });
    wrapper.appendChild(heading);
    if (field.subTitle) {
      wrapper.appendChild(
        creator.createSpan({
          css: "contextSubHeader",
          text: field.subTitle,
        }),
      );
    }
    return wrapper;
  },
  addFeatureInfoField: function (idPrefix, field) {
    var wrapper = creator.createDiv({
      css: "feature-info-ct",
      id: idPrefix + field.id + "-info-ct",
    });
    var heading = creator.createButton({ css: "info-heading info-disabled" });
    heading.appendChild(
      creator.createH3({
        text: field.title,
      }),
    );
    heading.appendChild(
      creator.createIcon({
        css: "icon-Chevron-down context-icon-style",
      }),
    );
    if (field.featureCount) {
      heading.appendChild(
        creator.createSpan({
          css: "feature-count",
          text: 0,
        }),
      );
    }
    //EKSEMPEL VPOR
    if (field.subTitle) {
      heading.appendChild(
        creator.createSpan({
          text: field.subTitle,
        }),
      );
    }
    $(heading).click(function (e) {
      if ($(e.currentTarget).hasClass("info-disabled") === false) {
        $(".feature-info-ct")
          .find("i")
          .each(function (idx, el) {
            if (
              el.parentElement != heading &&
              $(el).hasClass("icon-Chevron-upFill")
            ) {
              $(el)
                .toggleClass("icon-Chevron-down")
                .toggleClass("icon-Chevron-upFill");
            }
          });
        $(heading)
          .find("i")
          .toggleClass("icon-Chevron-down")
          .toggleClass("icon-Chevron-upFill");

        var currentArticle = $(e.currentTarget.parentElement).find("article");

        $(".feature-info-ct")
          .find("article")
          .each(function (idx, el) {
            if (el === currentArticle[0] && idx >= 0) {
              currentArticle.toggle();
              currentArticle.closest("i");
              //currentArticle.closest(".featureinfo-wrapper").animate({
              //    scrollTop: $(e.currentTarget).offset().top - 200
              //}, "slow");
            } else {
              $(el).hide();
            }
          });
      }
    });
    wrapper.appendChild(heading);
    wrapper.appendChild(creator.createArticle({}));

    return wrapper;
  },
  addDyplenkeField: function (bottomtext) {
    var wrapper = creator.createDiv({
      css: "feature-info-ct feature-info-ct-no-border",
    });
    wrapper.appendChild(
      creator.createH2({
        css: "info-heading-nohover info-heading-header navtogglerActive",
        innerHTML: bottomtext,
      }),
    );
    wrapper.appendChild(creator.createDiv({ id: "dyplenke-bottom-ct" }));
    return wrapper;
  },
  addPunktFeatureInfo: function (fields) {
    var section = creator.createSection({
      css: "featureinfo-wrapper feature-info-punkt",
    });
    section.appendChild(
      creator.createDiv({
        id: "punkt-info-ct",
        css: "feature-info-ct",
      }),
    );
    fields.forEach(function (field) {
      if (field.point) {
        if (!field.fields) {
          section.appendChild(privateFns.addFeatureInfoField("punkt-", field));
        } else {
          var parentField = privateFns.addFeatureInfoHeader("punkt-", field);
          field.fields.forEach(function (subFields) {
            parentField.appendChild(
              privateFns.addFeatureInfoField("punkt-", subFields),
            );
          });
          section.appendChild(parentField);
        }
      }
    });
    return section;
  },
  addFeatureInfoDetailsMenu: function () {
    var page = creator.createAside({
      css: "featureinfo-details",
    });
    page.setAttribute("tabIndex", -1);
    var topDiv = creator.createDiv({ css: "top-div" });
    topDiv.appendChild(
      creator.createButton({
        css: "maximize-this",
        ariaLabel: "Vis info om plan",
        onclick: function () {
          $(page).removeClass("featureinfo-details-minimized");
        },
      }),
    );
    topDiv.appendChild(
      creator.createButton({
        css: "close-me-featureinfo",
        ariaLabel: "Lukk detaljert informasjon",
        icon: true,
        iconClass: "icon-Close",
        onclick: function () {
          var target = $(".featureinfo-details");
          var featureInfo = $(".featureinfo");
          if (
            target.hasClass("standalone") === false &&
            featureInfo.hasClass("aside-show") === false
          ) {
            featureInfo.addClass("aside-show");
          }
          target.removeClass(
            "featureinfo-details-show aside-show standalone featureinfo-details-minimized",
          );
          featureInfo.removeClass("almost-hide-right");
          globals.clearSelectedFeatures();
        },
        tabIndex: -1,
      }),
    );
    page.appendChild(topDiv);
    page.appendChild(
      creator.createArticle({
        id: "featureinfo-details-ct",
      }),
    );
    return page;
  },
  initContextMenuInteraction: function (conf) {
    globals.mapclick = true;
    globals.map.on("click", function (e) {
      if (globals.mapclick) {
        privateFns.contextMenuInteractionHandler(e);
      }
    });
  },
  contextMenuInteractionHandler: function (e) {
    var abort = false;

    // Fjerner eventuelle popups
    globals.map.getOverlays().getArray()[0].setPosition(undefined);

    if (globals.clickInfoInProgress === false) {
      globals.clickInfoInProgress = true;

      // Fjerner eventuell tekst i søkefeltet
      $("#large-search").val("");

      var coords = e.coordinate;

      globals.map.forEachFeatureAtPixel(e.pixel, function (visibleFeature) {
        //HVIS TRUE HINDRER KLIKK PÅ EIENDOM VED KLIKK PÅ FEATURE. SKRIVE OM?!
        if (
          visibleFeature.get("T") ||
          visibleFeature.get("features") ||
          visibleFeature.get("SAKSNR") ||
          visibleFeature.get("name") === "clickFeature"
        ) {
          abort = true;
        } else if (
          visibleFeature.get("ADRID") ||
          visibleFeature.get("ADRESSE")
        ) {
          coords = visibleFeature.getGeometry().getCoordinates();
        }
      });
      if (abort === false) {
        var clickFeature = new Feature({
          name: "clickFeature",
          geometry: new Point(coords),
        });
        clickFeature.setStyle(
          new Style({
            image: new Icon({
              anchor: [0.5, 1],
              size: [32, 32],
              src: "./icons/Kart PinBlue.png",
            }),
          }),
        );
        var markerlayer = globals.map.getLayerById("fontmarkers");
        markerlayer.getSource().clear();
        markerlayer.getSource().addFeature(clickFeature);

        privateFns.handleMapClick(coords, null, config);
      } else {
        globals.clickInfoInProgress = false;
      }
    }
  },
  addPolygonStringToLink: function () {
    var format = new WKT();
    var markerlayer = globals.map.getLayerById("markers");
    var teiger = 0,
      teig = {},
      wktString = "";

    // Finner antall teiger
    markerlayer
      .getSource()
      .getFeatures()
      .forEach(function (f) {
        if (
          f.getGeometry().getType() === "Polygon" ||
          f.getGeometry().getType() === "MultiPolygon"
        ) {
          teiger += 1;
          teig = f;
        }
      });
    if (teiger === 1 && teig.getGeometry().getType() === "Polygon") {
      var wkt = format.writeFeature(teig);
      if (wkt.length < 1200) {
        wktString = wkt;
      }
    }
    return wktString;
  },
  handleMapClick: function (coord, originator, config, searchFeature) {
    var showContext = true;
    $("#search-result-page").remove();
    privateFns.hideExtendedMenu();
    if ($(window).width() < 992) {
      privateFns.hideLayerMenu();
    }
    if (
      (originator === "sok" || originator === "sak") &&
      $(window).width() < 992
    ) {
      showContext = false;
    }
    var featureInfoPage = $(".featureinfo");
    if (featureInfoPage.is(":visible") === false) {
      featureInfoPage.show();
    }
    if (featureInfoPage.hasClass("featureinfo-minimized")) {
      featureInfoPage.removeClass("featureinfo-minimized");
      featureInfoPage
        .find(".minimize-me")
        .find("i")
        .addClass("fa-window-minimize")
        .removeClass("fa-window-maximize");
    }
    if (searchFeature === undefined) {
      featureInfoPage.addClass("aside-show");
      $(".featureinfo-tip").addClass("featureinfo-tip-hide");
      if (showContext === false) {
        featureInfoPage.addClass("featureinfo-minimized");
        featureInfoPage
          .find(".minimize-me")
          .find("i")
          .removeClass("fa-window-minimize")
          .addClass("fa-window-maximize");
      }
    }
    if (globals.appConfig.contextMenu.minimize) {
      $($("#contextMinimize")[0].parentElement.parentElement).toggleClass(
        "featureinfo-minimized",
      );
      $("#contextMinimize")
        .find("i")
        .toggleClass("fa-window-minimize")
        .toggleClass("fa-window-maximize");
    }
    privateFns.getEiendomForCoordinate(coord, config, searchFeature);
  },
  hideExtendedMenu: function () {
    $(".featureinfo").show();
    $(".featureinfo").removeClass("almost-hide-right");
    $(".featureinfo-details").removeClass(
      "aside-show featureinfo-details-show",
    );
    $(".drop-downs").hide();
    $(".show-collapsible").removeClass("show-collapsible");
  },
  hideLayerMenu: function () {
    $(".navtoggler").removeClass("navtogglerActive");
    $(".navtoggler").addClass("navtoggler-toggled");
    $(".mapmenu").removeClass("nav-toggled");
  },
  getEiendomForCoordinate: function (coords, config, searchFeature) {
    var east = parseInt(coords[0], 10);
    var north = parseInt(coords[1], 10);
    $.ajax({
      url: globals.phpAutocomplete + "kontekstmeny?e=" + east + "&n=" + north,
      /**
       * @param r {string}
       * @param r.teigid
       */
      success: function (eiendomsInfo) {
        // Tømmer alle tidligere verdier fra kontekstmeny
        privateFns.clearContextMenu();

        if (eiendomsInfo.gnr || eiendomsInfo.teigid) {
          //Markerer eiendom i kartet
          privateFns.getEiendomPolygon(eiendomsInfo, config.contextMenu);
          //Fyller inn eiendomsinfo i kontekstmenyen
          privateFns.renderEiendomsInfo(eiendomsInfo, globals.intranett);

          //Fyller inn punktinfo i kontekstmenyen
          privateFns.renderPointInfo(east, north, eiendomsInfo);

          //Fyller resten av kontekstmenyen via konfig
          privateFns.getContextInfo(
            config.contextMenu,
            eiendomsInfo,
            coords,
            searchFeature,
          );
        } else {
          //TODO kommentert ut og skjuler kontekstmenyen når man ikke har eiendom.
          /*
					//TODO HENTE INFO FOR KUN PUNKT UTEN EIENDOM!!!
					privateFns.setNoEiendomInfo();
					// Henter info for punktet
					privateFns.renderPointInfo(east, north, eiendomsInfo);

					// Henter info om tema fra konfig-fil som kan vises uavhengig av eiendom
					privateFns.getContextInfo(config.contextMenu, {teigid: "", gnr: "", bnr: ""}, coords, searchFeature);*/
          $(".featureinfo").hide();
        }

        globals.clickInfoInProgress = false;
      },
      fail: function () {
        globals.clickInfoInProgress = false;
        console.error("fail");
      },
      error: function () {
        globals.clickInfoInProgress = false;
        console.error("error");
      },
    });
  },
  setNoEiendomInfo: function () {
    var target = $("#eiendom-info-ct");
    target.empty();
    target.append(
      creator.createDiv({
        text: "Fant ingen eiendom i valgt punkt. Klikk på fanen for punkt for å se eventuelle treff",
      }),
    );
    target.parent("section").find(".context-menu-loader").remove();

    $("#tab-punkt").find("a").click();
  },
  clearContextMenu: function () {
    var targets = $(".feature-info-ct");
    targets.find("article").empty();
    targets.find(".feature-count").html("0");
    // Legger til disabled-klasse og legger til loader
    targets
      .find(".info-heading")
      .addClass("info-disabled")
      .append(privateFns.addLoader());
  },
  addLoader: function () {
    var loader = creator.createDiv({ css: "context-menu-loader" });
    var icon = creator.createIcon({ css: "fa fa-spinner fa-pulse" });
    loader.appendChild(icon);
    return loader;
  },
  appendToFormaalCt: function (target, obj) {
    Object.keys(obj).forEach(function (key) {
      if (obj.hasOwnProperty(key)) {
        if (privateFns.checkIfFormaalAdded(target, key) === false) {
          target.appendChild(privateFns.createFormaalInfoRow(obj, key));
        }
      }
    });
  },
  checkIfFormaalAdded: function (target, key) {
    var added = false;
    var divs = $(target).find("div");
    divs.each(function (index, div) {
      if (key === div.innerHTML.substr(div.innerHTML.indexOf(":") + 2)) {
        added = true;
      }
    });
    return added;
  },
  getPlanMetadata: function (plannavn, target) {
    var url = globals.planmetaWSUrl + "plannavn=" + plannavn;
    $.ajax({
      url: url,
      success: function (response) {
        var layoutItem = config.contextMenu.featureClickLayout.regPlan;
        target.empty();
        if (layoutItem.modify) {
          response = layoutItem.modify(response);
        }
        if (layoutItem.header) {
          target.append("<h3>" + response[layoutItem.header] + "</h3>");
        }
        layoutItem.layout.forEach(function (item) {
          privateFns.createExtendedInfoElement(
            target[0],
            item,
            response,
            layoutItem,
          );
        });
      },
      fail: function () {
        console.error("fail");
      },
      error: function () {
        console.error("error");
      },
    });
  },
  renderFeatures: function (target, item, features) {
    if (item.filter) {
      features = privateFns.partition(features, item.filter)[0];
    }
    if (item.modify) {
      features = item.modify(features);
    }
    if (item.sort) {
      features.sort(item.sort);
    }
    if (features.length > 0) {
      target.find(".info-heading").removeClass("info-disabled");
      var featureArray = privateFns.createSortedFeatureArray(
        features,
        item.values,
      );
      if (
        item.layerCheckbox &&
        target.find(".info-heading").find("h3").html()
      ) {
        if (!target.find("article").find("input").length) {
          let layerName = target
            .find(".info-heading")
            .find("h3")
            .html()
            .toLowerCase();
          layerName = layerName.charAt(0).toUpperCase() + layerName.slice(1);
          target
            .find("article")
            .prepend(
              privateFns.createLayerCheckbox(
                target,
                item.layerId,
                "Vis kart for " + layerName,
              ),
            );
        }
      }
      if (
        item.showExtendedInfo &&
        target.find(".info-heading").find("h3").html()
      ) {
        target.find("article").append(
          creator.createButton({
            css: "click-area-btn feature-info-element",
            text: item.merInfoLink,
            onclick: function () {
              privateFns.showExtendedMenu();
              item.merInfoLayout.forEach(function (layoutItem) {
                privateFns.createExtendedInfoElement(
                  $("#featureinfo-details-ct")[0],
                  layoutItem,
                  {},
                  {},
                );
              });
            },
          }),
        );
      }
      privateFns.createInfoElements(
        target,
        featureArray,
        item,
        features.length,
      );
    }
  },

  //Henter ut verdier definert i konfig og kombinerer dem med verdier fra WFS
  createSortedFeatureArray: function (features, infoItem) {
    var arr = [],
      obj,
      collection;
    features.forEach(function (f) {
      var added = false,
        currentIdx = -1;
      arr.some(function (item, idx) {
        if (
          f.get(infoItem.counter) === item.counter &&
          f.get(infoItem.comparator) === item.comparator
        ) {
          currentIdx = idx;
          added = true;
        }
        return added;
      });
      if (added && infoItem.counter) {
        if (infoItem.subFields) {
          if (
            arr[currentIdx].subCollection[
              f.get(infoItem.subFields[0].value)
            ] === undefined
          ) {
            collection = new Collection();
            arr[currentIdx].subCollection[f.get(infoItem.subFields[0].value)] =
              collection;
          }
          arr[currentIdx].subCollection[
            f.get(infoItem.subFields[0].value)
          ].push(f);
        } else {
          arr[currentIdx].subCollection.features.push(f);
        }
      } else {
        obj = {};
        Object.keys(infoItem).forEach(function (field) {
          obj[field] = f.get(infoItem[field]);
          if (Array.isArray(infoItem[field])) {
            obj[field] = [];
            infoItem[field].forEach(function (val) {
              if (typeof val === "object") {
                var subObj = {};
                Object.keys(val).forEach(function (subVal) {
                  subObj[subVal] = f.get(val[subVal]);
                });
                obj[field].push(subObj);
              } else {
                obj[field].push(f.get(val));
              }
            });
          }
          if (typeof infoItem[field] === "function") {
            obj[field] = infoItem[field](f.get(field));
          }
        });
        collection = new Collection();
        collection.push(f);
        obj.subCollection = {};
        if (infoItem.subFields) {
          obj.subCollection[f.get(infoItem.subFields[0].value)] = collection;
        } else {
          obj.subCollection.features = collection;
        }
        arr.push(obj);
      }
    });
    return arr;
  },
  getEiendomPolygon: function (eiendomsInfo, contextConfig) {
    globals.map.getLayerById("markers").getSource().clear();
    $("body").css("cursor", "wait");
    $.ajax({
      url:
        globals.searchUrl +
        "&VERSION=1.1.0&SERVICE=WFS&REQUEST=GetFeature&TYPENAME=EIENDOM_WFS&Filter=<Filter><PropertyIsEqualTo><PropertyName>ID</PropertyName><Literal>" +
        eiendomsInfo.teigid +
        "</Literal></PropertyIsEqualTo></Filter>",
      success: function (response) {
        var format = privateFns.newWfsFormat("EIENDOM_WFS");
        var features = privateFns.readWfsFeatures(format, response);
        globals.gnr = features[0].values_.GARDSNR;
        globals.bnr = features[0].values_.BRUKSNR;
        globals.bbox = features[0].values_.boundedBy;
        $("#doklink").remove();
        globals.addFeaturesToOverlay(features, "markers");
        $("body").css("cursor", "default");

        // Legger til eventuelle dyplenker
        if (contextConfig.mode.bottom) {
          $("#dyplenke-bottom-ct").empty();
          contextConfig.dyplenker.forEach(function (lenke) {
            var currentUrl = lenke.url;
            if (currentUrl.indexOf("@(gnr)") >= 0) {
              currentUrl = currentUrl.replace("@(gnr)", eiendomsInfo.gnr);
            }
            if (currentUrl.indexOf("@(bnr)") >= 0) {
              currentUrl = currentUrl.replace("@(bnr)", eiendomsInfo.bnr);
            }
            if (currentUrl.indexOf("@(polygon)") >= 0) {
              currentUrl = currentUrl.replace(
                "@(polygon)",
                privateFns.addPolygonStringToLink(),
              );
            }
            $("#dyplenke-bottom-ct").append(
              globals.addLinkDiv({
                innerHTML: lenke.innerHTML,
                external: true,
                target: currentUrl,
              }),
            );
          });
        }
      },
    });
  },
  renderEiendomsInfo: function (obj, intranett) {
    var target = $("#eiendom-info-ct");
    target.empty();
    target.append(
      creator.createDiv({
        id: "info-ct-header",
        css: "info-ct-header",
        text: obj.gnr + "/" + obj.bnr + " <span>(gårds-/bruksnr)</span>",
      }),
    );
    target.append(
      creator.createDiv({
        text:
          "Bydel: " + globals.camelize(obj.bydel, obj.bydel.indexOf(" ") > 0),
      }),
    );
    if (obj.poststed) {
      target.append(
        creator.createDiv({
          text: globals.camelize(obj.poststed, true),
        }),
      );
    }
    target.append(
      creator.createDiv({
        css: "redText",
        text: obj.teiger,
      }),
    );
    var arealDiv = creator.createDiv({
      text: "Beregnet areal for valgt teig: " + obj.areal + "m²",
    });
    arealDiv.appendChild(
      creator.createButton({
        icon: true,
        iconClass: "icon-Alert-circle",
        onclick: function (e) {
          $(e.currentTarget.parentElement.parentElement)
            .find(".alert")
            .toggle();
        },
      }),
    );
    target.append(arealDiv);
    target.append(privateFns.addWarningDiv());
    if (intranett) {
      let Gnr = "00000";
      let Bnr = "0000";
      Gnr = Gnr.slice(0, -obj.gnr.toString().length) + obj.gnr;
      Bnr = Bnr.slice(0, -obj.bnr.toString().length) + obj.bnr;
      target.append(
        globals.addLinkDiv({
          innerHTML: "Se matrikkel og tinglysing",
          external: true,
          title: 'Åpner tjenesten "eiendomsinnsyn"',
          target: "https://eiendomsinnsyn.no/mnr/0301" + Gnr + Bnr + "0000000",
        }),
      );
    } else {
      target.append(
        globals.addLinkDiv({
          innerHTML: "Se matrikkel og tinglysing",
          external: true,
          title: 'Åpner tjenesten "eiendomsregisteret"',
          target:
            "https://eiendomsregisteret.kartverket.no/eiendom/0301/" +
            obj.gnr +
            "/" +
            obj.bnr,
        }),
      );
    }
  },
  addWarningDiv: function () {
    var div = creator.createDiv({
      css: "alert alert-info infoboks",
      text: "Nøyaktigheten på arealet som oppgis er avhengig av nøyaktigheten på grenseinformasjonen registrert i matrikkelen",
    });
    var button = creator.createButton({
      css: "btn btn-link btn-block",
      text: "Lukk",
      onclick: function () {
        $(div).hide();
      },
    });
    div.appendChild(button);
    return div;
  },
  renderPointInfo: function (e, n, obj) {
    var target = $("#punkt-info-ct");
    target.empty();
    target.append(
      creator.createDiv({
        css: "info-ct-header",
        innerHTML: "N: " + n + " Ø: " + e,
      }),
    );
    if (obj) {
      target.append(
        creator.createDiv({
          text: "Bydel: " + globals.camelize(obj.bydel),
        }),
      );
      if (obj.poststed) {
        target.append(
          creator.createDiv({
            text: globals.camelize(obj.poststed, true),
          }),
        );
      }
    }
  },
  getContextInfo: function (contextMenu, eiendom, coords, searchFeature) {
    contextMenu.loaders.forEach(function (loaderItem) {
      if (loaderItem.loaderType === "WFS") {
        privateFns.sendContextItemWFSRequest(
          contextMenu.mode.point,
          loaderItem,
          eiendom,
          coords,
          searchFeature,
        );
      } else if (loaderItem.loaderType === "WS") {
        var params = {
          teigid: eiendom.teigid || "",
          gnr: eiendom.gnr || "",
          bnr: eiendom.bnr || "",
          east: parseInt(coords[0], 10),
          north: parseInt(coords[1], 10),
        };
        privateFns.sendContextItemWSRequest(loaderItem, params, searchFeature);
      } else if (loaderItem.loaderType === "NOLOAD") {
        loaderItem.targets.forEach(function (targetItem) {
          var target = $("#" + targetItem.id + "-info-ct");
          target.find(".context-menu-loader").remove();
          privateFns.renderFeatures(target, targetItem, loaderItem.features);
        });
      }
    });
  },
  sendContextItemWFSRequest: function (punkt, item, eiendom, coords, sFeature) {
    var url =
        item.service +
        "&service=WFS&version=1.1.0&request=GetFeature&typeName=" +
        item.typeNames.join(","),
      j = 0,
      i = 0,
      and = false;
    var filter = "(<Filter>";
    if (item.filterItem.length > 1) {
      filter += "<AND>";
      and = true;
    }
    if (!item.table) {
      url += "&Filter=";
      while (j < item.filterItem.length) {
        filter +=
          "<PropertyIsEqualTo><PropertyName>" +
          item.filterItem[j] +
          "</PropertyName><Literal>" +
          eiendom[item.filterItem[j]] +
          "</Literal></PropertyIsEqualTo>";
        j += 1;
      }
      if (and) {
        filter += "</AND>";
      }
      filter += "</Filter>)";
      while (i < item.typeNames.length) {
        url += filter;
        i += 1;
      }
    } else {
      url += "&teigid=" + eiendom[item.filterItem[0]];
    }
    $.ajax({
      url: url,
      success: function (response) {
        var format = privateFns.newWfsFormat(item.typeNames);
        var features = privateFns.readWfsFeatures(format, response);
        if (features.length > 0) {
          features = globals.sortByProximity(features, coords);
          item.targets.forEach(function (targetItem) {
            var target = $("#" + targetItem.id + "-info-ct");
            target.find(".context-menu-loader").remove();
            privateFns.renderFeatures(target, targetItem, features);
            if (punkt) {
              privateFns.renderFeaturesForPoint(targetItem, features, coords);
            }
            if (sFeature) {
              privateFns.showExtendedInfoFromSearchItem(
                sFeature,
                item,
                features,
              );
            }
          });
        } else {
          item.targets.forEach(function (targetItem) {
            var target = $("#" + targetItem.id + "-info-ct");
            target.find(".context-menu-loader").remove();
            var pointTarget = $("#punkt-" + targetItem.id + "-info-ct");
            pointTarget.find(".context-menu-loader").remove();
            if (
              target.find(".feature-count")[0] &&
              !target.find(".feature-count")[0].innerHTML > 0
            ) {
              target.find(".feature-count").html(0);
            }
            if (
              pointTarget.find(".feature-count")[0] &&
              pointTarget.find(".feature-count")[0] &&
              !pointTarget.find(".feature-count")[0].innerHTML > 0
            ) {
              pointTarget.find(".feature-count").html(0);
            }
          });
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(jqXHR, textStatus, errorThrown);
      },
    });
  },
  //195102776
  showExtendedInfoFromSearchItem: function (feature, item, allItems) {
    if (item.targets[0].id === "saker") {
      var tmpObj = {};
      var target = $("#featureinfo-details-ct");
      target.empty();

      $("#" + feature.get("contextId") + "-info-ct")
        .find(".info-heading")
        .click();

      if ($(window).width() > 1024) {
        privateFns.showExtendedMenu();
      } else {
        $(".featureinfo-details")
          .addClass("aside-show featureinfo-details-minimized")
          .removeClass("featureinfo-details-show")
          .find(".maximize-this")
          .html(feature.get(item.searchInfo.itemKey));
      }
      item.targets[0].layout.forEach(function (i, idx) {
        if (i.value) {
          tmpObj[i.value] = feature.get(item.targets[0].layout[idx].value);
        } else if (i.urlParam) {
          tmpObj[i.urlParam] = feature.get(
            item.targets[0].layout[idx].urlParam,
          );
        }
      });

      var allFeatures = privateFns.createSortedFeatureArray(
        allItems,
        item.targets[0].values,
      );
      var searchedFeature = privateFns.createSortedFeatureArray(
        [feature],
        item.targets[0].values,
      );
      var searchedFeature = allFeatures.filter(function filter(feature) {
        return searchedFeature[0].B2 === feature.saksnr;
      });
      searchedFeature[0].subCollection.features.array_[0].values_ =
        searchedFeature[0];
      target.append(
        privateFns.createExtendedInfoSection(
          item.targets[0],
          item.targets[0].layout,
          searchedFeature[0],
        ),
      );
      var hiddenDiv = creator.createDiv({
        css: "hidden-featureinfo",
      });
      var expandBtn = creator.createButton({
        text:
          "Vis andre byggesaker på eiendommen (" + (allItems.length - 1) + ")",
        css: "btn btn-link",
        onclick: function (e) {
          if (e.currentTarget.innerHTML.indexOf("Vis") >= 0) {
            e.currentTarget.innerHTML = e.currentTarget.innerHTML.replace(
              "Vis",
              "Skjul",
            );
          } else {
            e.currentTarget.innerHTML = e.currentTarget.innerHTML.replace(
              "Skjul",
              "Vis",
            );
          }
          $(hiddenDiv).toggle();
        },
      });
      target.append(expandBtn);
      allFeatures.forEach(function (itm) {
        itm.subCollection.features.array_[0].values_ = itm;
        privateFns.showExtendedInfoFromItem(
          itm,
          item.targets[0],
          false,
          hiddenDiv,
        );
      });
      target.append(hiddenDiv);
    }
  },
  //Lager kopi av array. tilsvarer [...array]
  arrayWithoutHoles: function (arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    }
  },
  //Sorterer features inn i to arrays avhengig av insendt funksjon. F.eks om plannavn inneholder "KDP"
  partition: function (array, isValid) {
    return array.reduce(
      function (arg, elem) {
        var pass = arg[0];
        var fail = arg[1];
        return isValid(elem)
          ? [[].concat(privateFns.arrayWithoutHoles(pass), elem), fail]
          : [pass, [].concat(privateFns.arrayWithoutHoles(fail), elem)];
      },
      [[], []],
    );
  },
  //TODO FORMATERES FOR Å HÅNDTERE SAMME KONFIG SOM WFS
  sendContextItemWSRequest: function (item, params, sFeature) {
    var allItems;

    var url =
      item.service +
      "teigid=" +
      params.teigid +
      "&gnr=" +
      params.gnr +
      "&bnr=" +
      params.bnr +
      "&east=" +
      params.east +
      "&north=" +
      params.north;
    $.ajax({
      url: url,
      success: function (r) {
        var responseObj = JSON.parse(r);
        if (responseObj.teig) {
          var teigObj = responseObj.teig;
          Object.keys(teigObj).forEach(function (key) {
            var target = $("#" + key + "-info-ct");
            if (target.length > 0 && item.targets[key]) {
              //privateFns.renderObjectItems(target, teigObj[key], item.targets[key]);
            }
            if (sFeature && key === sFeature.get("contextId")) {
              allItems = teigObj[key];
            }
          });
          if (sFeature) {
            privateFns.showExtendedInfoFromSearchItem(
              sFeature,
              item.targets[sFeature.get("contextId")],
              allItems,
            );
          }
        }
        if (responseObj.punkt) {
          var punktObj = responseObj.punkt;
          Object.keys(punktObj).forEach(function (key) {
            var target = $("#punkt-" + key + "-info-ct");
            if (target.length > 0 && item.targets[key]) {
              //privateFns.renderObjectItems(target, punktObj[key], item.targets[key]);
            }
          });
        }
      },
    });
  },
  newWfsFormat: function (typeName) {
    return new WFS({
      featureNS: "http://mapserver.gis.umn.edu/mapserver",
      featureType: typeName,
    });
  },
  readWfsFeatures: function (format, response) {
    return format.readFeatures(response, {
      dataProjection: "EPSG:32632",
      featureProjection: "EPSG:32632",
    });
  },
  createLayerCheckbox: function (target, inputId, labelContent) {
    var idPrefix = "";
    if (target.attr("id").indexOf("punkt") >= 0) {
      idPrefix = "punkt-";
    } else {
      idPrefix = "eie-";
    }
    idPrefix += "content-show-";
    var div = creator.createDiv({ css: "context-layer-checkbox" });
    var layerCheckbox = $("#" + inputId);
    var input = creator.createInput({
      type: "checkbox",
      id: idPrefix + inputId,
      onchange: privateFns.onContextMenuLayerCheckboxChange(layerCheckbox),
    });
    input.checked = layerCheckbox.prop("checked");
    var label = creator.createLabel({
      htmlfor: idPrefix + inputId,
      text: labelContent,
    });
    div.appendChild(input);
    div.appendChild(label);
    return div;
  },
  //TODO, DENNE TRIGGES FRA WSREQUEST
  renderObjectItems: function (target, obj, config) {},

  //TODO SKRIVES OM, BØR BRUKE KONFIG VERDIER
  onContextMenuLayerCheckboxChange: function (layerCheckbox) {
    return function (e) {
      var kplayer = false;
      // Hvis kartlaget som slås på er fra kommuneplanen:
      if (e.target.id.indexOf("kp") >= 0) {
        kplayer = true;
      }
      if (
        e.target.id === "eie-content-show-kp_tema_ikke_juridisk_luftforurensing"
      ) {
        layerCheckbox = $(
          "#kp_tema_ikke_juridisk_luftforurensing_t2, #kp_tema_ikke_juridisk_luftforurensing_t3",
        );
      }
      if (e.target.checked) {
        if (kplayer) {
          globals.checkedContextLayers += 1;
          privateFns.onKpLayerShow(e.target);
        }
        layerCheckbox.prop("checked", true);
        layerCheckbox.change();
      } else {
        layerCheckbox.prop("indeterminate", false);
        layerCheckbox.prop("checked", false);
        layerCheckbox.change();
        if (kplayer) {
          globals.checkedContextLayers -= 1;
          if (globals.checkedContextLayers === 0) {
            privateFns.onKpLayerHide();
          }
        }
      }
      // Sørger for at checkbox endres både i eiendoms- og punktvisning
      if (e.target.id.indexOf("punkt") >= 0) {
        $("#eie-" + e.target.id.replace("punkt-", "")).prop(
          "checked",
          e.target.checked,
        );
      } else {
        $("#punkt-" + e.target.id.replace("eie-", "")).prop(
          "checked",
          e.target.checked,
        );
      }
    };
  },
  onKpLayerShow: function (tipTarget) {
    var hiddenLayers = [];
    var layerIdx = 0;

    globals.forAllLayers(globals.map, function (layer) {
      if (layer.get("displayInLayerMenu") && layer.getVisible()) {
        if (
          layer.get("parentId") !== "baselayers" &&
          layer.get("parentId") !== "kartdetaljer"
        ) {
          if (
            layer.get("layerId") &&
            layer.get("layerId").indexOf("kp") < 0 &&
            layer.get("layerId") !== "kartdetaljer"
          ) {
            $("#" + layer.get("layerId"))
              .prop("checked", false)
              .prop("indeterminate", false);
            layer.setVisible(false);
            hiddenLayers.push(layerIdx);
          }
        }
      }
      layerIdx += 1;
    });

    if (localStorage.getItem("planinnsyn-tmp-hidden-layers") === null) {
      localStorage.setItem("planinnsyn-tmp-hidden-layers", hiddenLayers);
    }
    if (localStorage.getItem("planinnsyn-toggle-layers-tip") === null) {
      privateFns.onKpLayerShowTip(tipTarget);
    }
  },
  onKpLayerHide: function () {
    var layerIdx = 0,
      lyrCollection = {},
      hiddenLayers = [];
    if (localStorage.getItem("planinnsyn-tmp-hidden-layers")) {
      hiddenLayers = localStorage
        .getItem("planinnsyn-tmp-hidden-layers")
        .split(",");
    }
    hiddenLayers.forEach(function (lItem) {
      lyrCollection[lItem] = true;
    });
    globals.forAllLayers(globals.map, function (layer) {
      if (lyrCollection[layerIdx]) {
        $("#" + layer.get("layerId"))
          .prop("checked", true)
          .change();
      }
      layerIdx += 1;
    });
    localStorage.removeItem("planinnsyn-tmp-hidden-layers");
  },
  onKpLayerShowTip: function (tipTarget) {
    if (globals.tipWinShown === false) {
      var tipWin = creator.createDiv({
        css: "tip-win-toggle-layer",
      });
      var article = creator.createArticle({});
      var section = creator.createSection({
        text: "Kartene i venstremenyen slås av når du velger dette kartet. Om du fjerner avhukingen, slås kartene på igjen.",
      });
      article.appendChild(section);
      tipWin.appendChild(article);
      var btnWrapper = creator.createDiv({
        css: "tip-win-btn-wrapper",
      });
      btnWrapper.appendChild(
        creator.createButton({
          css: "btn btn-default",
          text: "OK",
          onclick: function () {
            $(tipWin).remove();
          },
        }),
      );
      tipWin.appendChild(btnWrapper);
      var inputWrapper = creator.createDiv({
        css: "tip-win-input-wrapper",
      });
      inputWrapper.appendChild(
        creator.createInput({
          type: "checkbox",
          id: "hide-tip-win-toggle-layer",
          onchange: function (e) {
            if (e.currentTarget.checked) {
              localStorage.setItem("planinnsyn-toggle-layers-tip", true);
            } else {
              localStorage.removeItem("planinnsyn-toggle-layers-tip");
            }
          },
        }),
      );
      inputWrapper.appendChild(
        creator.createLabel({
          htmlfor: "hide-tip-win-toggle-layer",
          text: "Ikke vis igjen",
        }),
      );
      tipWin.appendChild(inputWrapper);
      $(tipWin).css("top", $(tipTarget).offset().top - 32);
      $("#map").append(tipWin);
      globals.tipWinShown = true;
    }
  },
  createInfoElements: function (
    target,
    features,
    item,
    featureCount,
    externalTarget,
  ) {
    var createdDivs = [],
      firstRowWrapper,
      addedFeatures = [];
    features.some(function (feature, index) {
      var stop = false;
      var wrapper = creator.createDiv({ css: "kommuneplan-gruppe-ct" });
      var added = false,
        currentIndex = -1,
        addedFeature;
      if (index >= item.maxSubFields && !externalTarget) {
        wrapper.appendChild(
          creator.createButton({
            text: item.showAllText + " (" + features.length + ")",
            css: "looklike-btn-link",
            onclick: function () {
              privateFns.showExtendedMenu();
              $("#featureinfo-details-ct").empty();
              privateFns.createInfoElements(
                $("#featureinfo-details-ct"),
                features,
                item,
                featureCount,
                true,
              );
            },
          }),
        );
        createdDivs.push(wrapper);
        stop = true;
      } else {
        addedFeatures.some(function (f, idx) {
          //index > idx &&
          if (
            feature[item.comparator] &&
            feature[item.comparator] === addedFeatures[idx][item.comparator]
          ) {
            currentIndex = idx;
            addedFeature = addedFeatures[idx];
            added = true;
          }
          return added;
        });
        if (added) {
          //Hvis boksen er lagt til legges bare layout feature til dersom de finnes.
          item.layout.forEach(function (row) {
            if (!row.unique) {
              createdDivs[currentIndex].appendChild(
                privateFns.createRow(row, feature, item),
              );
            } else if (row.hover) {
              //TODO ENDRET FIKS HVIS FORTSATT FEIL MED GEOMETRIER
              //Hvis unik rad og row.hover: Legger til feature i subcollection til raden som er lagt til.
              feature.subCollection.features.array_.forEach(function (f) {
                addedFeature.subCollection.features.push(f);
              });
            }
          });
          added = false;
        } else {
          item.layout.forEach(function (row) {
            wrapper.appendChild(privateFns.createRow(row, feature, item));
            addedFeatures.push(feature);
            createdDivs.push(wrapper);
          });
          $(wrapper)
            .find(".click-area-btn")
            .click(function (e) {
              privateFns.showExtendedMenu();
              privateFns.showExtendedInfoFromItem(feature, item, true);
              e.stopPropagation();
            });
        }
      }
      return stop;
    });

    if (item.counter === "feature") {
      target.find(".feature-count").html(featureCount);
    } else {
      var count = parseInt(
        globals.uniqueJsonFeatureValueCount(features, item.counter),
      );
      if (target.find(".feature-count")[0]) {
        count += parseInt(target.find(".feature-count")[0].innerHTML);
      }
      target.find(".feature-count").html(count);
    }
    createdDivs.forEach(function (div) {
      if (externalTarget) {
        target[0].appendChild(div);
      } else {
        target.find("article").append(div);
      }
    });
  },
  createRow: function (row, feature, item) {
    var triggerClass = row.triggerField ? "click-area-btn" : "";
    var halfling = row.halfling ? " two-col " : "";
    var strongClass = row.strong ? " font-strong " : "";
    var elementClass = triggerClass + halfling + strongClass;
    var createdRow;
    if (row.type === "header") {
      elementClass = feature[row.value] ? elementClass : ""; //Fjerner elementClass hvis altText for header.
      return creator.createDiv({
        css: elementClass,
        text: feature[row.value] ? feature[row.value] : row.altText,
      });
    }
    if (row.type === "itemCheckbox") {
      createdRow = privateFns.createItemCheckbox(feature, row);
    }
    if (row.type === "layerCheckbox") {
      createdRow = privateFns.createLayerCheckBox(row, feature);
    }
    if (row.type === "legendFeature") {
      createdRow = privateFns.createLegend(item, row, feature);
    }
    if (row.type === "paragraph") {
      createdRow = privateFns.createParagraph(row, feature, elementClass);
    }
    if (row.type === "link") {
      createdRow = privateFns.createLink(row, feature);
    }
    if (row.type === "conditional") {
      if (row.condition) {
        if (row[feature[row.condition]]) {
          if (Array.isArray(row[feature[row.condition]])) {
            createdRow = creator.createDiv({});
            row[feature[row.condition]].forEach(function (conditionalRow) {
              createdRow.appendChild(
                privateFns.createRow(conditionalRow, feature, item),
              );
            });
          } else {
            createdRow = privateFns.createRow(
              row[feature[row.condition]],
              feature,
              item,
            );
          }
        } else if (row[""]) {
          createdRow = privateFns.createRow(row[""], feature, item);
        }
      } else if (row.notEmptyCondition) {
        if (feature[row.notEmptyCondition]) {
          if (Array.isArray(row[feature[row.notEmptyCondition]])) {
            createdRow = creator.createDiv({});
            row[feature[row.notEmptyCondition]].forEach(
              function (conditionalRow) {
                createdRow.appendChild(
                  privateFns.createRow(conditionalRow, feature, item),
                );
              },
            );
          } else {
            createdRow = privateFns.createRow(row["exist"], feature, item);
          }
        } else if (row[""]) {
          createdRow = privateFns.createRow(row[""], feature, item);
        } else {
          return (createdRow = creator.createDiv({}));
        }
      }
    }
    if (row.triggerField) {
      $(createdRow).click(function (e) {
        privateFns.showExtendedMenu();
        privateFns.showExtendedInfoFromItem(feature, item, true);
        e.stopPropagation();
      });
    }
    return createdRow;
  },
  showExtendedInfoFromItem: function (item, config, clearContent, altTarget) {
    var target;
    if (altTarget) {
      target = $(altTarget);
    } else {
      target = $("#featureinfo-details-ct");
    }
    if (clearContent) {
      target.empty();
    }
    if (config.extendedInfo && config.extendedInfo.external) {
      privateFns.getExternalinfo(
        config.extendedInfo.url,
        config.extendedInfo.urlKey,
        item,
        config,
        target,
      );
    } else if (config.extendedInfo && config.extendedInfo.internal) {
      var textContainer = creator.createParagraph({});

      var wrapper = creator.createSection({ css: "info-container" });
      wrapper.appendChild(textContainer);
      target.append(wrapper);

      var key = "";
      if (item.labelValues[0] === "H310_2 - Ras- og skredfare (steinsprang)") {
        key = item.key + "_2";
      } else if (item.labelValues[0] === "H320_1 - Flomfare (stormflo)") {
        key = item.key + "_1";
      } else if (item.labelValues[0] === "H320_2 - Flomfare (elveflom)") {
        key = item.key + "_2";
      } else {
        key = item.key;
      }

      $(textContainer).html(infotextGenerator.getInfoTextFor(key));

      var legend = creator.createDiv({ css: "legend-row" });

      var legendclass = "legend-symb legend-";
      legendclass += config.legendPrefix ? config.legendPrefix : "";
      legendclass += item.legendValues.join("-").toLowerCase();
      legendclass += item.legendSuffix ? item.legendSuffix : "";
      legend.appendChild(
        creator.createDiv({
          css: legendclass,
          text: "&nbsp;",
        }),
      );

      var labeltext = "";
      labeltext += config.labelPrefix ? config.labelPrefix : "";
      labeltext += item.labelValues.join("-");
      labeltext += item.labelSuffix ? item.labelSuffix : "";
      legend.appendChild(
        creator.createDiv({
          css: "legend-text",
          text: labeltext,
        }),
      );
      target.append(legend);
    } else if (config.extendedInfo) {
      target.append(
        privateFns.createExtendedInfoSection(config.extendedInfo, config, item),
      );
    } else {
      target.append(privateFns.createExtendedInfoSection(config, config, item));
    }
  },
  getExternalinfo: function (url, urlkey, obj, config, target) {
    var url = url + obj[urlkey];
    $.ajax({
      url: url,
      success: function (response) {
        var extended = config.extendedInfo ? config.extendedInfo : config;
        response.urlkey = obj[urlkey];
        target.append(
          privateFns.createExtendedInfoSection(extended, config, response),
        );
      },
      fail: function () {
        console.error("fail");
      },
      error: function () {
        console.error("error");
      },
    });
  },
  createExtendedInfoSection: function (
    extendedConfig,
    config,
    obj,
    formerContent,
    target,
  ) {
    var section = creator.createSection({ css: "feature-info-element" });
    if (extendedConfig.modify) {
      obj = extendedConfig.modify(obj);
    }
    if (extendedConfig.header) {
      section.appendChild(
        creator.createH3({
          text: obj[extendedConfig.header]
            ? obj[extendedConfig.header]
            : extendedConfig.header,
          css: "menuPadding",
        }),
      );
    }
    if (obj && obj.subCollection) {
      obj.subCollection.features.array_.forEach(function (feature) {
        var subSection = creator.createSection({});
        section.appendChild(subSection);
        if (extendedConfig.hover) {
          $(subSection).hover(privateFns.onSubCtInfoRowHover([feature]));
        }
        extendedConfig.layout.forEach(function (layoutItem) {
          privateFns.createExtendedInfoElement(
            subSection,
            layoutItem,
            feature.values_,
            config,
          );
        });
      });
    } else {
      if (extendedConfig.hover) {
        //TODO
        //$(section).hover(privateFns.onSubCtInfoRowHover([feature]));
      }
      extendedConfig.layout.forEach(function (layoutItem) {
        privateFns.createExtendedInfoElement(section, layoutItem, obj, config);
      });
    }
    if (formerContent) {
      var backBtn = creator.createButton({
        css: "icon-Chevron-rightFill returnBtn",
        text: "<p style='font-size:15px; float: left; font-family:OsloSans; margin-top: 4px;'>Tilbake</p>",
        onclick: function (e) {
          target.empty();
          target.append(formerContent);
        },
      });
      section.prepend(backBtn);
    }
    return section;
  },
  //Lager nivå 2 for klikk i nivå 1
  createExtendedInfoElement: function (target, layoutItem, obj, config) {
    var url,
      empty = false;
    if (layoutItem.type === "conditional") {
      if (layoutItem[obj[layoutItem.condition]]) {
        if (Array.isArray(layoutItem[obj[layoutItem.condition]])) {
          layoutItem[obj[layoutItem.condition]].forEach(
            function (conditionalItem) {
              privateFns.createExtendedInfoElement(
                target,
                conditionalItem,
                obj,
                config,
              );
            },
          );
        } else {
          privateFns.createExtendedInfoElement(
            target,
            layoutItem[obj[layoutItem.condition]],
            obj,
            config,
          );
        }
      }
    }
    if (layoutItem.type === "header") {
      target.appendChild(
        creator.createH5({
          text: obj[layoutItem.value]
            ? obj[layoutItem.value]
            : layoutItem.alt
              ? layoutItem.alt
              : layoutItem.value,
          css: "menuPadding",
        }),
      );
    }
    if (layoutItem.type === "header4") {
      target.appendChild(
        creator.createH4({
          text: obj[layoutItem.value]
            ? obj[layoutItem.value]
            : layoutItem.alt
              ? layoutItem.alt
              : layoutItem.value,
          css: "menuPadding",
        }),
      );
    }
    if (layoutItem.type === "itemCheckbox") {
      //TODO
    }
    if (layoutItem.type === "layerCheckbox") {
      //TODO
    }
    if (layoutItem.type === "legendFeature") {
      //TODO
    }
    if (layoutItem.type === "paragraph") {
      var tekst = layoutItem.prefix ? layoutItem.prefix : "";
      ((tekst += obj[layoutItem.value]
        ? obj[layoutItem.value]
        : layoutItem.alt
          ? layoutItem.alt
          : layoutItem.value),
        target.appendChild(
          creator.createParagraph({
            text: tekst,
            //className: "menuPadding"
            css: "",
          }),
        ));
    }
    if (layoutItem.type === "link") {
      if (
        !layoutItem.addCondition ||
        (layoutItem.addCondition && obj[layoutItem.addCondition])
      ) {
        if (layoutItem.href && obj[layoutItem.href]) {
          url = obj[layoutItem.href];
        } else if (layoutItem.url) {
          url = layoutItem.url;
          if (Array.isArray(layoutItem.urlParam)) {
            layoutItem.urlParam.forEach(function (param) {
              var par = obj[param] ? obj[param] : param;
              url = url.replace("%PARAM%", par);
            });
          } else if (obj[layoutItem.urlParam]) {
            url += obj[layoutItem.urlParam];
          }
        }
        if (layoutItem.postfix) {
          url += layoutItem.postfix;
        }
        var lenketekst = obj[layoutItem.text]
          ? obj[layoutItem.text]
          : layoutItem.text;
        target.appendChild(
          globals.addLinkDiv({
            external: true,
            innerHTML: lenketekst,
            target: url,
          }),
        );
      }
    }
    if (layoutItem.type === "row") {
      target.appendChild(
        creator.createDiv({
          text: (layoutItem.key || "") + obj[layoutItem.value],
          css: "menuPadding",
        }),
      );
    }
    if (layoutItem.type === "div") {
      if (layoutItem.children) {
        var div = creator.createDiv({});
        layoutItem.children.forEach(function (item) {
          privateFns.createExtendedInfoElement(div, item, obj, config);
        });
        target.appendChild(div);
      } else {
        target.appendChild(
          creator.createDiv({
            text: (layoutItem.key || "") + obj[layoutItem.value],
            css: "menuPadding",
          }),
        );
      }
    }
    if (layoutItem.type === "span") {
      target.appendChild(
        creator.createSpan({
          text: obj[layoutItem.value] + layoutItem.postfix,
        }),
      );
    }
    if (layoutItem.type === "button") {
      target.appendChild(
        creator.createButton({
          text: obj[layoutItem.value],
          css: layoutItem.classname,
          onclick: function () {
            layoutItem.clickfunction(
              obj[layoutItem.value],
              $("#featureinfo-details-ct"),
              privateFns,
              config,
            );
          },
        }),
      );
    }
    if (layoutItem.type === "multi") {
      if (
        obj[layoutItem.value] &&
        obj[layoutItem.value][0] &&
        obj[layoutItem.value][0].id !== 0
      ) {
        if (layoutItem.header) {
          privateFns.createExtendedInfoElement(
            target,
            layoutItem.header,
            obj,
            config,
          );
        }
        obj[layoutItem.value].forEach(function (item) {
          privateFns.createExtendedInfoElement(
            target,
            layoutItem.layout,
            item,
            config,
          );
        });
      }
    }
    if (layoutItem.triggerField) {
      $(target).click(function (e) {
        privateFns.showExtendedMenu();
        privateFns.showExtendedInfoFromItem(feature, layoutItem, true);
        e.stopPropagation();
      });
    }
  },
  createItemCheckbox: function (obj, row) {
    var div = creator.createDiv({ css: "two-col" });

    var input = creator.createInput({
      type: "radio",
      name: "show-plan",
      id: "vis-" + obj.header,
    });

    var label = creator.createLabel({
      hrmlfor: "vis-" + obj.header,
      text: row.tekst,
    });
    div.appendChild(input);
    div.appendChild(label);

    input.onclick = function (e) {
      globals.map.removeLayer(globals.map.getLayerById("highlight"));
      if (
        e.target.id === globals.lastRadioClicked &&
        $(e.target).data("isChecked")
      ) {
        e.target.checked = false;
        $(e.target).data("isChecked", false);
      } else {
        globals.highlightPlan(obj, row, true, label);
        $(e.target).data("isChecked", true);
      }
      globals.lastRadioClicked = e.target.id;
    };
    if (obj.header) {
      return div;
    } else {
      return creator.createDiv({});
    }
  },
  createLink: function (row, feature) {
    var url,
      add = true;
    if (row.href && feature[row.href]) {
      url = feature[row.href];
    } else if (row.url) {
      url = feature[row.url] ? feature[row.url] : row.url;
      if (!row.addCondition || feature[row.addCondition]) {
        if (Array.isArray(row.urlParam)) {
          row.urlParam.forEach(function (param) {
            if (feature[param]) {
              url = url.replace("%PARAM%", feature[param]);
            } else {
              add = false;
            }
          });
          url += row.postfix ? row.postfix : "";
        } else {
          url += feature[row.urlParam] ? feature[row.urlParam] : "";
          url += row.postfix ? row.postfix : "";
        }
      } else {
        add = false;
      }
    }
    if (add) {
      return globals.addLinkDiv({
        external: true,
        innerHTML: feature[row.text] ? feature[row.text] : row.text,
        target: url,
      });
    } else {
      return creator.createDiv({});
    }
  },
  createParagraph: function (row, feature, elementClass) {
    var elementClass = elementClass ? elementClass : "";
    var div = creator.createDiv({});
    if (Array.isArray(feature[row.value])) {
      feature[row.value].forEach(function (paragraph) {
        div.appendChild(
          creator.createDiv({
            text: paragraph,
            css: elementClass,
          }),
        );
      });
    } else {
      var innerText = feature[row.value]
        ? feature[row.value]
        : row.alt
          ? row.alt
          : row.value;
      div.appendChild(
        creator.createDiv({
          text: innerText,
          css: elementClass,
        }),
      );
    }
    return div;
  },
  createLayerCheckBox: function (row, feature) {
    var div = creator.createDiv({ css: "context-layer-checkbox" });
    var layerCheckbox = $("#" + feature.layerCheckbox);
    var input = creator.createInput({
      type: "checkbox",
      id: "eie-content-show-" + feature.layerCheckbox,
    });
    input.checked = layerCheckbox.prop("checked");
    input.onchange = privateFns.onContextMenuLayerCheckboxChange(layerCheckbox);
    div.appendChild(input);
    var label = creator.createLabel({
      htmlfor: "eie-content-show-" + feature.layerCheckbox,
      text: row.tekst,
    });
    div.appendChild(label);
    return div;
  },
  createLegend: function (item, row, feature) {
    var triggerClass = row.triggerField ? "click-area" : "";
    var halfling = row.halfling ? " two-col " : "";
    var strongClass = row.strong ? " font-strong " : "";
    var elementClass = triggerClass + halfling + strongClass;

    var div = creator.createDiv({
      css: "feature-info-element " + elementClass,
    });
    var div2 = creator.createDiv({});
    var div3 = creator.createDiv({ css: "legend-row legend-row-tight" });
    var prefix = row.legendPrefix ? row.legendPrefix : "";
    if (!row.collapse) {
      div3.appendChild(
        creator.createDiv({
          css:
            "legend-symb legend-" +
            prefix +
            feature.legendValues.join("-").toLowerCase().split(" ").join("-"),
          text: "&nbsp;",
          style: { float: "left" },
        }),
      );
    }
    var btnClass = "legend-text ";
    btnClass += row.labelClass ? row.labelClass : "";
    var geometryType = item.geometryType
      ? privateFns.getGeometryType(feature.subCollection, "features")
      : "";
    var labeltext = stringInject(row.labelValue, feature.labelValues);
    div3.appendChild(
      creator.createDiv({
        css: btnClass,
        text: geometryType + labeltext,
      }),
    );
    if (row.counter) {
      div3.appendChild(
        creator.createSpan({
          text: feature.subCollection.features.get("length"),
        }),
      );
    }
    div2.appendChild(div3);
    div.appendChild(div2);
    if (row.hover) {
      $(div).hover(
        privateFns.onSubCtInfoRowHover(feature.subCollection.features),
      );
    }
    if (row.triggerText) {
      var btnDiv = creator.createDiv({
        css: "looklike-btn-link click-area",
        text: row.triggerText,
      });
      div3.appendChild(btnDiv);
      $(btnDiv).click(function (e) {
        privateFns.showExtendedMenu();
        privateFns.showExtendedInfoFromItem(feature, item, true);
        e.stopPropagation();
      });
    }
    return div;
  },
  //TODO SKRIVE OM TIL Å BRUKE KONFIG?
  getGeometryType: function (obj, key) {
    var row = creator.createDiv({});
    var geom = "";
    var type = obj["features"].item(0).getGeometry().getType();
    if (type === "Polygon") {
      geom = "Flate: ";
    } else if (type === "MultiPolygon") {
      geom = "Flate: ";
    } else if (type === "LineString") {
      geom = "Linje: ";
    } else if (type === "Point") {
      geom = "Punkt: ";
    } else {
      console.error("Mangler håndtering av geometritype");
    }
    return geom;
  },
  renderFeaturesForPoint: function (config, features, coords) {
    var pFeatures = [];
    var target = $("#punkt-" + config.id + "-info-ct");

    target.find(".context-menu-loader").remove();
    features.forEach(function (f) {
      var minDist = globals.getDistanceBetweenFeatureAndPoint(f, coords);
      // Finner objekter som berører eller ligger mindre enn en halv meter unna punktet det ble klikket i
      if (f.getGeometry().intersectsCoordinate(coords) || minDist < 0.5) {
        pFeatures.push(f);
      }
    });
    if (pFeatures.length > 0) {
      privateFns.renderFeatures(target, config, pFeatures);
    }
  },
  onSubCtInfoRowHover: function (collection) {
    var layer = globals.map.getLayerById("hoverhighlight");
    return function (e) {
      var hoverClass = "highlight-feature";
      if (
        /*e.currentTarget.parentElement.className.indexOf("kommuneplan") >= 0 && */ $(
          e.currentTarget,
        ).hasClass("click-area")
      ) {
        hoverClass = "highlight-feature-with-click";
      }
      if (e.type === "mouseenter") {
        collection.forEach(function (feature) {
          layer.getSource().addFeature(feature);
        });
        $(e.currentTarget).addClass(hoverClass);
      } else {
        layer.getSource().clear();
        $(e.currentTarget).removeClass(hoverClass);
      }
    };
  },
  showExtendedMenu: function () {
    $(".featureinfo").addClass("almost-hide-right");
    $(".featureinfo-details")
      .removeClass("featureinfo-details-minimized standalone")
      .addClass("featureinfo-details-show");
  },
  showExtendedInfoFromFeatures: function (params, obj) {
    $("#featureinfo-details-ct").empty();
    if (params.showAsLegend) {
      privateFns.createExtendedLegendHeader(obj);
    }
    obj.subCollection.features.forEach(function (feature) {
      $("#featureinfo-details-ct").append(
        privateFns.createExtendedFeatureInfo(feature, params),
      );
    });
  },
  createExtendedLegendHeader: function (obj) {
    var div = creator.createDiv({ css: "legend-row" });
    div.appendChild(
      creator.createDiv({
        css: "legend-" + obj.legendValues.join("-").toLowerCase(),
        text: "&nbsp;",
      }),
    );
    div.appendChild(
      creator.createDiv({
        css: "legend-text",
        text: globals.camelize(obj.labelValues.join(" - ")),
      }),
    );
    $("#featureinfo-details-ct").append(div);
  },
  showClickInfo: function (e, target, conf) {
    var features = e.selected;
    let targetLayer;
    for (var key in e.target.featureLayerAssociation_) {
      targetLayer = e.target.featureLayerAssociation_[key].values_.layerId;
    }
    var config = conf.contextMenu.featureClickLayout[targetLayer];
    if (config.external) {
      var item = {};
      item[config.urlKey] = features[0].get(config.urlKey);
      privateFns.getExternalinfo(
        config.url,
        config.urlKey,
        item,
        config,
        target,
      );
    } else if (features[0].get("features")) {
      // Hvis clustrede features (byggesaker og postliste)
      if (features[0].get("features")[0].get("H")) {
        target.append(
          "<h3>" + features[0].get("features")[0].get("H") + "</h3>",
        );
      }
      features[0].get("features").forEach(function (f) {
        privateFns.createClickInfoForFeature(f, target, config);
      });
    } else {
      privateFns.createClickInfoForFeature(features[0], target, config);
    }
  },
  createClickInfoForFeature: function (f, target, layout) {
    if (layout.header) {
      var header = f.get(layout.header) ? f.get(layout.header) : layout.header;
      target.append("<h3>" + header + "</h3>");
    }
    var wrapper = creator.createSection({});
    if (layout.cssClass) {
      wrapper.className = layout.cssClass;
    }
    layout.layout.forEach(function (el) {
      if (el.type === "header") {
        wrapper.appendChild(
          creator.createH5({
            text: f.get(el.value),
            css: "menuPadding",
          }),
        );
      } else if (el.type === "paragraph") {
        var inner = f.get(el.prefix)
          ? f.get(el.prefix)
          : el.prefix
            ? el.prefix
            : "";
        inner += f.get(el.value) ? f.get(el.value) : el.alt ? el.alt : el.value;
        inner += f.get(el.suffix)
          ? f.get(el.suffix)
          : el.suffix
            ? el.suffix
            : "";
        wrapper.append(
          creator.createParagraph({
            text: inner,
          }),
        );
      } else if (el.type === "link") {
        var lenke = creator.createDiv({});
        var lenketekst = f.get(el.text) ? f.get(el.text) : el.text;
        lenke.innerHTML = lenketekst + "<i class='icon-new-window'></i>";
        lenke.className = "looklike-btn-link link-div";
        var url = el.url ? el.url : f.get(el.href) ? f.get(el.href) : false;
        if (url) {
          url += f.get(el.urlParam)
            ? f.get(el.urlParam)
            : el.urlParam
              ? el.urlParam
              : "";
          url += el.postfix ? el.postfix : "";
          $(lenke).click(privateFns.sakInfoOnClick(url));
          wrapper.append(lenke);
        }
      }
    });
    target.append(wrapper);
  },
  sakInfoOnClick: function (url) {
    return function (e) {
      window.open(url, "_blank");
      e.stopPropagation();
    };
  },
};
export default {
  initiate: function (conf) {
    config = conf;
    var featureInfo = creator.createAside({ css: "featureinfo" });
    featureInfo.setAttribute("tabIndex", -1);
    featureInfo.appendChild(privateFns.addFeatureInfoTopDiv());
    if (conf.contextMenu.mode.area && conf.contextMenu.mode.point) {
      featureInfo.appendChild(
        privateFns.addTabMenu(conf.contextMenu.title1, conf.contextMenu.title2),
      );
    }
    if (conf.contextMenu.mode.area) {
      featureInfo.appendChild(
        privateFns.addEiendomFeatureInfo(
          conf.contextMenu.mode.bottom,
          conf.contextMenu.fields,
        ),
      );
    }
    if (conf.contextMenu.mode.point) {
      featureInfo.appendChild(
        privateFns.addPunktFeatureInfo(conf.contextMenu.fields),
      );
    }
    $("#header").after(featureInfo);
    $(featureInfo).after(privateFns.addFeatureInfoDetailsMenu());

    /* Setter opp kart-klikk-interaksjon for kontekstmeny */
    if (!conf.contextMenu.disableMapClick) {
      privateFns.initContextMenuInteraction(conf);
    }

    featureInfo.setAttribute("aria-hidden", "true");
    $(featureInfo).hide();
    globals.handleMapClick = privateFns.handleMapClick;
    globals.exposedGetPlanMetadata = privateFns.getPlanMetadata;
    globals.exposedHandleMapClick = privateFns.handleMapClick;
    globals.exposedAppendToFormaalCt = privateFns.appendToFormaalCt;
  },
  /** Funksjoner for featureInfo */
  showFeatureInfoForType: function (e, conf) {
    var featureInfoWin = $(".featureinfo-details");
    /* Skjule kontekstmeny nivå 1 */
    $(".featureinfo").removeClass("almost-hide-right aside-show");
    /* Fjerner eventuelle andre visningsklasser fra kontekstmeny nivå 3 */
    featureInfoWin.removeClass("featureinfo-details-show");
    /* Åpner kontektsmeny nivå 3 */
    featureInfoWin.addClass("aside-show standalone");
    var target = $("#featureinfo-details-ct");
    target.empty();
    privateFns.showClickInfo(e, target, conf);
  },
  //exposedListPlanInfo: privateFns.listPlanInfo,
};
